import { pluginFactory } from '@atlaskit/editor-common/utils';

import { aiExperiencePromptActionPluginKey } from './prompt-action-plugin-key';
import { reducer } from './reducer';
import type { AIPromptActionPluginState } from './states';

export const createInitialState = (): AIPromptActionPluginState => {
	return {
		actionSource: undefined,
		actionType: undefined,
		prompt: undefined,
	};
};
export const { createPluginState, createCommand, getPluginState } = pluginFactory(
	aiExperiencePromptActionPluginKey,
	reducer,
);
